<template>
  <v-app>
    <v-main class="bg-image">
      <DeleteUser />
    </v-main>
  </v-app>
</template>

<script>
import DeleteUser from './components/DeleteUser';

export default {
  name: 'App',

  components: {
    DeleteUser,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.bg-image {
  background-image: url(assets/watermark.svg);
  background-color: #47cb87;
  background-size: 200%;
  background-repeat: no-repeat;
}
</style>
